export default __webpack_public_path__ + "static/media/playngo.4647d99f.svg";